{% block hueb_seo_content_title %}
    <h2> {{ $tc('hueb-seo.general.mainMenuItemArticle') }} </h2>
{% endblock %}

{% block hueb_seo_options_card %}
    <sw-card :title="$tc('hueb-seo.card.labelOptions')">
        <sw-container columns="1fr 1fr" gap="0px 30px">
            <sw-switch-field :label="$tc('hueb-seo.card.labelChildSwitch')"
                             v-model:value="includeChildren">
            </sw-switch-field>
            <sw-switch-field :label="$tc('hueb-seo.card.labelOverwriteSwitch')"
                             v-model:value="overwrite">
            </sw-switch-field>
            <sw-switch-field :label="$tc('hueb-seo.card.labelVariantSwitch')"
                             :helpText="$tc('hueb-seo.card.helpVariantSwitch')"
                             v-model:value="variant">
            </sw-switch-field>
        </sw-container>
        <mt-select
            :placeholder="$tc('hueb-seo.card.placeholderTemplateOption')"
            :label="$tc('hueb-seo.card.labelLoadTemplate')"
            v-model="templateSelected"
            @update:model-value="onSelectTemplate"
            :options="templateOptions">
        </mt-select>
        <sw-button
            :isLoading="isLoadingTemplate"
            :disabled="!templateSelected"
            variant="primary"
            @click="onClickSaveTemplate">
            {{ $tc('hueb-seo.general.saveTemplateButtonText') }}
        </sw-button>
        <sw-button
            :disabled="!templateSelected"
            variant="danger"
            @click="onClickDeleteTemplate">
            {{ $tc('hueb-seo.general.deleteTemplateButtonText') }}
        </sw-button>
    </sw-card>
{%  endblock %}
